import React from 'react';
import { IconEdit, IconTrash } from 'design-system/icons';
import { SeparatedList } from 'design-system/SeparatedList';
import { SettingsItem } from 'design-system/SettingsItem';
const EditCategoryModalContent = ({ onPressEdit, onPressDelete, }) => (<SeparatedList>
    <SettingsItem icon={<IconEdit gradientKey="ultimate"/>} title="Edit category" onPress={onPressEdit}/>
    <SettingsItem icon={<IconTrash colorKey="negative"/>} title="Delete category" onPress={onPressDelete}/>
  </SeparatedList>);
export default EditCategoryModalContent;
